import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/shareReplay';
import * as moment from 'moment';
import { Login } from '../api/models/login';
import { ApiService } from '../api/services/api.service';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class AuthenticationService {
  public bytes;

  constructor(private http: HttpClient, private api: ApiService, private cookieService: CookieService) {

  }

  user(): any {
    // import * as CryptoJS from 'crypto-js';
    this.bytes = CryptoJS.AES.decrypt(localStorage.getItem('user'), 'meg@Moon29');
    const data = JSON.parse(this.bytes.toString(CryptoJS.enc.Utf8));

    return JSON.parse(data);
  }

  login(username: string, password: string) {
    this.logout();
    return this.api.login({ username, password })
      .do(resp => this.setSession(resp));
  }

  private setSession(authResponse) {
    // const expiresAt = moment().add(authResponse.expiresIn, 'second');
    localStorage.setItem('token', authResponse.token);
    // localStorage.setItem('user', JSON.stringify(authResponse.user));
    localStorage.setItem('user', CryptoJS.AES.encrypt(JSON.stringify(authResponse.user), 'meg@Moon29').toString());
    // localStorage.setItem('expires_at', JSON.stringify(expiresAt.valueOf()));
    this.cookieService.set( 'val@1999Cry0', CryptoJS.AES.encrypt(JSON.stringify(authResponse.user.ID_USER), 'meg@Moon29').toString(), 360);
  }

  logout() {
    this.api.logout().subscribe(
      resp => {
        //  console.log('da goi ham api logout -----------', resp);
         this.cookieService.delete('val@1999Cry0');
      },
      err => {
         console.log(' loi logout ----------');
      },
      () => {}
    );
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('study');
    // localStorage.removeItem('expires_at');
  }

  public isLoggedIn() {
    return moment().isBefore(this.getExpiration());
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  getExpiration() {
    const expiration = localStorage.getItem('expires_at');
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  logoutAuto() {
    this.bytes = CryptoJS.AES.decrypt(this.cookieService.get('val@1999Cry0'), 'meg@Moon29');
    if(this.bytes){
      // console.log('id_useraaa');
    }
    let id_user = JSON.parse(this.bytes.toString(CryptoJS.enc.Utf8));
    // console.log('id_user',id_user);
    this.api.logoutAuto(id_user).subscribe(
      resp => {
        // console.log('da goi ham api logoutAuto -----------', resp);
        this.cookieService.delete('val@1999Cry0');
      },
      err => {
         console.log('logout error!');
      },
      () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('study');
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/authentication/authentication.service.ts